import * as uuid from 'uuid';

import {FlowchartMetadata} from 'processes/graph-builder/flowchart-viz/FlowchartVizConstants';
import {ProcessTaskSchemaForGraphBuilderValidation} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

import {ProcessFlowchartGraphQL} from '../../../../../graphql-fragments/processes/__generated/ProcessFlowchartGraphQL';
import {
  ProcessFlowchartStaticNodeAnalyticsData,
  ProcessStaticFlowchart,
} from '../ProcessFlowchartVizConstants';
import {convertFlowchartGqlToProcessStaticFlowchart} from './convertFlowchartGqlToProcessFlowchart';

interface BuildStaticFlowchartStructureFromGqlParams {
  flowchartStructure: ProcessFlowchartGraphQL | null;
  schema: ProcessTaskSchemaForGraphBuilderValidation;
  nodeAnalytics?: ProcessFlowchartStaticNodeAnalyticsData;
  metadata?: FlowchartMetadata;
}

export default function buildStaticFlowchartStructureFromGql({
  flowchartStructure,
  schema,
  nodeAnalytics,
  metadata,
}: BuildStaticFlowchartStructureFromGqlParams): ProcessStaticFlowchart {
  const flowchartClientId = uuid.v4();
  if (flowchartStructure == null) {
    return {clientId: flowchartClientId, nodes: [], edges: []};
  }

  const flowchart = convertFlowchartGqlToProcessStaticFlowchart(flowchartStructure);

  const {nodes, edges} = flowchart;
  nodes.forEach((node) => {
    node.analyticsData = {
      ...(node.analyticsData != null ? node.analyticsData : {}),
      ...(nodeAnalytics != null ? nodeAnalytics : {}),
    };
  });
  return {
    clientId: flowchartClientId,
    nodes,
    edges,
    metadata,
  };
}
